<ap-field
  #datepickerField
  [title]="filterColumn().label"
  [datepicker]="true"
  dpType="single"
  class="w-100"
  [dpRange]="true"
  [(dpSelectedDates)]="selected"
  [disabled]="isDisabled()"
  [error]="hasError()"
  [useCustomValidation]="true"
  (dpOnDateInvalid)="invalidDateHandler($event)"
  (onShow)="showHandler($event)"
  (dpSelectedDatesChange)="updateDateHandler($event)">
  <input appkit-field />
</ap-field>
@if (hasError()) {
  <p class="ap-field-validation-error text-end ap-pr-spacing-4">
    {{ 'formValidations.invalidDate' | translate }}
  </p>
}
